import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService } from 'src/app/modules/core/services/message.service';
import { LoginPopupComponent } from '../login-popup/login-popup.component';
import { SupportChatService } from '../../services/support-chat.service';

@Component({
  selector: 'app-sticky-toolbar',
  templateUrl: './sticky-toolbar.component.html',
  styleUrls: ['./sticky-toolbar.component.scss'],
  providers: [DialogService, DynamicDialogRef],
})
export class StickyToolbarComponent implements OnInit {
  expanded = false;
  private loginRef: DynamicDialogRef;

  constructor(
    public supportChat: SupportChatService,
    private dialogService: DialogService,
    private messageService: MessageService,
    private translateService: TranslateService,
  ) { }

  ngOnInit(): void {
  }
  expand(): any {
    this.expanded = !this.expanded;
  }

  async openLiveChat(): Promise<void> {
    try {
      const result = await this.supportChat.open();
      if (result === 'login-required') {
        // Same dialog + options as the header login button.
        this.loginRef = this.dialogService.open(LoginPopupComponent, {
          showHeader: true,
          dismissableMask: true,
          closable: true,
          styleClass: 'login-modal',
          contentStyle: { 'border-radius': '4px', padding: '0', 'z-index': '999' },
        });
      }
    } catch (e) {
      this.messageService.showPopup(
        this.translateService.instant('SUPPORT.UNAVAILABLE'),
        'alert',
        'fail',
        'p0Popup'
      );
    }
  }
}
